export default __webpack_public_path__ + "static/media/favorite-fill.026a7685.svg";